import CEO from '../assets/team/ceo.webp'
import COO from '../assets/team/coo.webp'
import architect_designer1 from '../assets/team/architectural_designer1.webp'
import architect_designer2 from '../assets/team/architectural_designer2.webp'
import architect_designer3 from '../assets/team/architectural_designer3.webp'
import BD_officer from '../assets/team/BD_officer.png'
import interior_designer from '../assets/team/interior_designer.webp'
import project_manager from '../assets/team/project_manager.webp'
import senior_architect from '../assets/team/senior_architect.webp'
import team_lead from '../assets/team/team_lead.webp'


export default {
  CEO,
  COO,
  architect_designer1,
  architect_designer2,
  architect_designer3,
  BD_officer,
  interior_designer,
  project_manager,
  senior_architect,
  team_lead
}
